import { render } from "./MediaDemo.vue?vue&type=template&id=801e76d2&scoped=true"
import script from "./MediaDemo.vue?vue&type=script&lang=js"
export * from "./MediaDemo.vue?vue&type=script&lang=js"

import "./MediaDemo.vue?vue&type=style&index=0&id=801e76d2&lang=scss&scoped=true"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-801e76d2"]])

export default __exports__